/**
 * Import Dependency
 */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import * as navbarActions from '../../actions/components/navbar'
import * as basketActions from '../../actions/components/basket'
/**
 * Import Component
 */
import NavBarLite from '../../components/NavBarLite'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {
    isFilteredByMe: state.basket.isFilteredByMe,
    isSwitchOnEditMode: state.isSwitchOnEditMode,
    orders: state.orders,
  }
}

const mapDispatchToProps = (dispatch) => {
  const { switchClearAllOrdersMode } = bindActionCreators(navbarActions, dispatch)
  const { switchEditMode } = bindActionCreators(navbarActions, dispatch)
  const { setFilteredByMe } = bindActionCreators(basketActions, dispatch)

  return {
    switchClearAllOrdersMode,
    switchEditMode,
    setFilteredByMe,
  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(NavBarLite)))



// WEBPACK FOOTER //
// ./src/containers/components/NavBarLite.js